import React, { memo } from 'react'
import { Typography } from '@mui/material'
import { titleCaps } from 'utils/universal'
import { formatLargeTransmission } from 'utils/vehicles'
import NumberFormat from 'react-number-format'

const VehicleFullName = ({
  vehicle, sxProps, showBulls = true, ...props
}) => {
  return (
    <Typography
      variant="body2"
      sx={sxProps}
      {...props}
    >
      {vehicle?.year}
      {' '}
      {showBulls && '•'}
      {' '}
      {titleCaps(vehicle?.maker)}
      {' '}
      {showBulls && '•'}
      {' '}
      {titleCaps(vehicle?.model)}
      {' '}
      {showBulls && '•'}
      {' '}
      {titleCaps(vehicle?.trim)}
      {' '}
      {showBulls && '•'}
      {' '}
      {vehicle?.cesviTransmission && (
        <>
          {titleCaps(formatLargeTransmission(vehicle?.cesviTransmission))}
        </>
      )}
      {' '}
      {showBulls && '•'}
      {' '}
      {vehicle?.exteriorColor && (
        titleCaps(vehicle?.exteriorColor)
      )}
      {' '}
      {showBulls && '•'}
      {vehicle?.mileage && (
        <NumberFormat
          value={vehicle?.mileage}
          displayType="text"
          thousandSeparator
          suffix="kms"
        />
      )}
      {' '}
      {showBulls && '•'}
      {' '}
      {titleCaps(vehicle?.cesviFuel)}
    </Typography>
  )
}

export default memo(VehicleFullName)
